module.exports = __webpack_public_path__ + "static/img/Geos-2022-Isabela.f391a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Isabela.png
// module id = o6Oh
// module chunks = 0